import { BrowserRouter, Route , Routes} from 'react-router-dom'
import Home from './components/home'
import config from './coreFiles/config';
import './App.css';

function App() {
  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route path={`${config.BASE_URL}`} element={<Home  />} />
      </Routes>
    </BrowserRouter>
  </>
  );
}

export default App;
